import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { logger } from './utils/logger';

// Error handling for initial render
const handleError = (error: Error) => {
  logger.error('Application initialization error:', error);
  const root = document.getElementById('root');
  if (root) {
    root.innerHTML = `
      <div style="
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px;
        text-align: center;
        font-family: system-ui, -apple-system, sans-serif;
      ">
        <h1 style="color: #4B5563; margin-bottom: 16px;">Unable to Load Application</h1>
        <p style="color: #6B7280; max-width: 500px;">
          We're experiencing technical difficulties. Please try refreshing the page or contact support if the issue persists.
        </p>
        <button onclick="window.location.reload()" style="
          margin-top: 16px;
          padding: 8px 16px;
          background-color: #10B981;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        ">
          Refresh Page
        </button>
      </div>
    `;
  }
};

try {
  const root = document.getElementById('root');
  if (!root) throw new Error('Root element not found');

  const appRoot = createRoot(root);
  
  appRoot.render(
    <StrictMode>
      <App />
    </StrictMode>
  );

  logger.info('Application initialized successfully');
} catch (error) {
  handleError(error instanceof Error ? error : new Error('Unknown initialization error'));
}
